<p-autoComplete
  [dropdown]="false"
  [showClear]="true"
  [forceSelection]="true"
  [multiple]="false"
  [delay]="500"
  [(ngModel)]="selected"
  [suggestions]="suggestions"
  [optionLabel]="getItemLabelProperty()"
  (completeMethod)="onLazyLoad($event)"
  (onClear)="onClear($event)"
  (blur)="onTouched()"
  (keydown)="onKeyDown($event)"
  [disabled]="disabled"
  [placeholder]="!disabled && !readonly ? 'Enter SOC Code or job title and select a valid option (e.g., 29‑1291.00 – Acupuncturists)' : ''"
  class="w-full"
  (onSelect)="onSelected($event)"
  (ngModelChange)="handleChange($event)"
  [(ngModel)]="value"
  [readonly]="readonly"
  [showClear]="!readonly"
/>
